import z from "zod";

export function optionSchema<T extends z.ZodType>(valueSchema: T) {
  return z.object({ value: valueSchema, label: z.string() });
}
